// habits.ts - Modern Habit Tracker with Custom Modal & 14-day Heatmap
export {};
let currentHabits: any[] = [];

// Define functions globally at module top level
(window as any).openAddHabitModal = function() {
    const modalEl = document.getElementById('add-habit-modal');
    const nameInput = document.getElementById('habit-name-input') as HTMLInputElement | null;
    const descInput = document.getElementById('habit-desc-input') as HTMLInputElement | null;
    const colorInput = document.getElementById('habit-color-input') as HTMLInputElement | null;

    if (!modalEl) return;
    if (nameInput) nameInput.value = '';
    if (descInput) descInput.value = '';
    if (colorInput) colorInput.value = '#10b981';

    modalEl.classList.add('active');
    modalEl.onclick = (e) => {
        if (e.target === modalEl) (window as any).closeAddHabitModal();
    };

    setTimeout(() => {
        if (nameInput) nameInput.focus();
    }, 50);
};

(window as any).closeAddHabitModal = function() {
    const modalEl = document.getElementById('add-habit-modal');
    if (modalEl) modalEl.classList.remove('active');
};

(window as any).saveHabitFromModal = async function() {
    const nameInput = document.getElementById('habit-name-input') as HTMLInputElement | null;
    const descInput = document.getElementById('habit-desc-input') as HTMLInputElement | null;
    const colorInput = document.getElementById('habit-color-input') as HTMLInputElement | null;

    const name = nameInput ? nameInput.value.trim() : '';
    if (!name) {
        if ((window as any).showMessage) (window as any).showMessage('Введіть назву звички', 'error');
        else alert('Будь ласка, введіть назву звички!');
        return;
    }
    const description = descInput ? descInput.value.trim() : '';
    const color = colorInput ? colorInput.value : '#10b981';

    try {
        const res = await fetch('/api/habits.php?action=create', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name, description, color })
        });
        const text = await res.text();
        let data: any = {};
        try {
            data = JSON.parse(text);
        } catch (_) {
            console.error('Non-JSON response:', text);
            alert('Помилка сервера: ' + text.slice(0, 100));
            return;
        }

        if (data.success) {
            if ((window as any).showMessage) (window as any).showMessage('Звичку успішно створено!', 'success');
            (window as any).closeAddHabitModal();
            (window as any).loadHabits();
        } else {
            if ((window as any).showMessage) (window as any).showMessage(data.error || 'Помилка створення звички', 'error');
            else alert(data.error || 'Помилка створення звички');
        }
    } catch (e: any) {
        console.error('Failed to create habit:', e);
        alert('Помилка з\'єднання: ' + (e.message || e));
    }
};

async function loadHabits() {
    const gridEl = document.getElementById('habits-grid');
    if (!gridEl) return;
    try {
        const res = await fetch('/api/habits.php?action=list');
        const data = await res.json();
        if (data.success) {
            currentHabits = data.data;
            renderHabits();
        }
    } catch (e) {
        console.error('Failed to load habits', e);
    }
}
(window as any).loadHabits = loadHabits;

function calculateStreak(history: Record<string, string>): number {
    let streak = 0;
    const today = new Date();
    
    for (let i = 0; i < 30; i++) {
        const d = new Date(today);
        d.setDate(d.getDate() - i);
        const dateStr = d.toISOString().slice(0, 10);
        
        if (history[dateStr] === 'completed') {
            streak++;
        } else if (i === 0) {
            continue;
        } else {
            break;
        }
    }
    return streak;
}

function renderHabits() {
    const gridEl = document.getElementById('habits-grid');
    if (!gridEl) return;
    gridEl.innerHTML = '';

    if (currentHabits.length === 0) {
        gridEl.innerHTML = `
            <div style="grid-column: 1 / -1; text-align: center; padding: 48px 24px; color: var(--text-dim);">
                <i class="ri-calendar-check-line" style="font-size: 40px; color: rgba(255,255,255,0.15); display: block; margin-bottom: 12px;"></i>
                <h3 style="color: #fff; margin: 0 0 8px 0; font-size: 16px;">Список звичок порожній</h3>
                <p style="font-size: 13px; margin: 0;">Натисніть "+ Додати звичку" зверху, щоб створити першу звичку</p>
            </div>
        `;
        return;
    }

    const today = new Date();

    currentHabits.forEach(habit => {
        const historyMap = habit.history || {};
        const streak = calculateStreak(historyMap);
        const isCompletedToday = habit.today_status === 'completed';

        const card = document.createElement('div');
        card.className = 'habit-card';
        card.style.borderTop = `3px solid ${habit.color || '#3b82f6'}`;

        // Header
        const header = document.createElement('div');
        header.className = 'habit-card-header';

        const titleBox = document.createElement('div');
        titleBox.className = 'habit-title-box';

        const title = document.createElement('h3');
        title.className = 'habit-title';
        title.innerHTML = `<i class="ri-checkbox-circle-fill" style="color: ${habit.color || '#3b82f6'};"></i> ${escapeHtml(habit.name)}`;

        const desc = document.createElement('p');
        desc.className = 'habit-desc';
        desc.innerText = habit.description || 'Щоденна звичка';

        titleBox.appendChild(title);
        titleBox.appendChild(desc);

        const streakBadge = document.createElement('div');
        streakBadge.className = 'habit-streak-badge';
        streakBadge.innerHTML = `<i class="ri-fire-line"></i> ${streak} ${pluralizeDays(streak)}`;

        header.appendChild(titleBox);
        header.appendChild(streakBadge);

        // Heatmap (14 days)
        const heatmap = document.createElement('div');
        heatmap.className = 'habit-heatmap';

        const heatmapLabel = document.createElement('div');
        heatmapLabel.className = 'heatmap-label';
        heatmapLabel.innerHTML = `<span>Історія за 14 днів</span><span>${isCompletedToday ? 'Сьогодні виконано ✓' : 'Сьогодні'}</span>`;

        const dotsContainer = document.createElement('div');
        dotsContainer.className = 'heatmap-dots';

        for (let i = 13; i >= 0; i--) {
            const d = new Date(today);
            d.setDate(d.getDate() - i);
            const dateStr = d.toISOString().slice(0, 10);
            const isCompleted = historyMap[dateStr] === 'completed';
            const isToday = i === 0;

            const dot = document.createElement('div');
            dot.className = `heatmap-dot${isCompleted ? ' active' : ''}${isToday ? ' today' : ''}`;
            dot.title = `${dateStr}: ${isCompleted ? 'Виконано' : 'Не відмічено'}`;
            dotsContainer.appendChild(dot);
        }

        heatmap.appendChild(heatmapLabel);
        heatmap.appendChild(dotsContainer);

        // Action Button
        const toggleBtn = document.createElement('button');
        toggleBtn.className = `habit-action-btn ${isCompletedToday ? 'completed' : 'pending'}`;
        toggleBtn.innerHTML = isCompletedToday
            ? `<i class="ri-checkbox-circle-line"></i> Виконано сьогодні`
            : `<i class="ri-add-circle-line"></i> Відмітити виконання`;

        toggleBtn.onclick = async () => {
            const newStatus = isCompletedToday ? 'none' : 'completed';
            try {
                await fetch('/api/habits.php?action=log', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ habit_id: habit.id, status: newStatus })
                });
                loadHabits();
            } catch (e) {
                console.error(e);
            }
        };

        card.appendChild(header);
        card.appendChild(heatmap);
        card.appendChild(toggleBtn);
        gridEl.appendChild(card);
    });
}

function pluralizeDays(n: number): string {
    if (n === 1) return 'день';
    if (n >= 2 && n <= 4) return 'дні';
    return 'днів';
}

function escapeHtml(str: string) {
    return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

// Global Document Event Delegation for 100% Click Reliability
document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement | null;
    if (!target) return;
    if (target.closest('#add-habit-save-btn')) {
        e.preventDefault();
        (window as any).saveHabitFromModal();
    } else if (target.closest('#add-habit-cancel-btn')) {
        e.preventDefault();
        (window as any).closeAddHabitModal();
    } else if (target.closest('#add-habit-btn')) {
        e.preventDefault();
        (window as any).openAddHabitModal();
    }
});

// Tab Switch Listener
const tabBtn = document.querySelector('button[data-tab="habits"]');
if (tabBtn) {
    tabBtn.addEventListener('click', () => {
        loadHabits();
    });
}

loadHabits();
